<template>
  <v-menu offset-y nudge-bottom="22" :nudge-right="center ? 75 : null" min-width="175" left
    :elevation="$vuetify.theme.dark ? 9 : 8">
    <!-- Activator -->
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" class="d-flex align-center mx-4" v-on="on">
        <v-img :src="FLAG_SRC[$i18n.locale] || FLAG_SRC.en" :alt="$i18n.locale" height="14px" width="22px" />
      </div>
    </template>

    <!-- Options List -->
    <v-list>
      <v-list-item-group :value="$i18n.locale" @change="updateActiveLocale">
        <v-list-item v-for="locale in locales" :key="locale.locale" :value="locale.locale">
          <v-img :src="locale.img" height="14px" width="22px" :alt="locale.locale" class="me-2" />
          <v-list-item-title>{{ locale.title }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { defaultLanguage, languageHeaderName, languageKeys } from '@/config'
import { parseLanguageFromStartLocation } from '@/helpers/queryLanguageHelper'
import { loadLanguageAsync } from '@/plugins/i18n'
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { onMounted } from '@vue/composition-api'

export default {
  props: {
    center: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { root }) {
    const { isRtl } = useAppConfig()

    // Static image map (no dynamic require)
    const FLAG_SRC = {
      sr_latin: require('@/assets/images/flags/sr_latin.png'),
      en: require('@/assets/images/flags/en.png'),
      ba: require('@/assets/images/flags/ba.png'),           // keep if you use BA
      de: require('@/assets/images/flags/de.png'),
      'de-AT': require('@/assets/images/flags/austria.png'), // Austrian flag
    }

    // Frontend alias: Austrian uses German packs/headers
    const LOCALE_ALIAS = { 'de-AT': 'de' }

    const updateActiveLocale = async (locale) => {
      if (!locale) return
      const base = LOCALE_ALIAS[locale] || locale

      // RTL only for Arabic language
      isRtl.value = locale === 'ar'
      localStorage.setItem('lang', locale)

      // Libraries that don’t have 'de-AT' get 'de'
      root.$vuetify.lang.current = base
      root.$moment.locale(base)

      // Backend must always receive 'de' for Austrian
      root.$http.defaults.headers.common[languageHeaderName] =
        languageKeys[locale] || languageKeys[base]

      // Load messages for the base (e.g., 'de')
      await loadLanguageAsync(base)

      // IMPORTANT: set the selected locale AFTER loading so the activator flag stays 'de-AT'
      root.$i18n.locale = locale
    }

    onMounted(async () => {
      const { route, router } = useRouter()
      const lang =
        parseLanguageFromStartLocation(router.history._startLocation) ||
        route.value.query.lang ||
        localStorage.getItem('lang')

      const candidate = lang && lang !== 'undefined' ? lang : defaultLanguage
      localStorage.setItem('lang', candidate)
      await updateActiveLocale(candidate)
    })

    const locales = [
      { title: 'Srpski', img: FLAG_SRC['sr_latin'], locale: 'sr_latin' },
      { title: 'English', img: FLAG_SRC['en'], locale: 'en' },
      { title: 'German', img: FLAG_SRC['de'], locale: 'de' },
      { title: 'Austrian', img: FLAG_SRC['de-AT'], locale: 'de-AT' },
    ]

    return {
      FLAG_SRC,
      locales,
      updateActiveLocale,
    }
  },
}
</script>
